export class CircularBuffer {
    historyLength: number;
    history: any[];
    writeIndex: number;
    zeroIndex: number;
    hasLooped: boolean;
    length: number;

    constructor(historyLength: number) {
        this.historyLength = historyLength;
        this.history = Array(historyLength).fill(null);
        this.writeIndex = 0;
        this.zeroIndex = 0;
        this.hasLooped = false;
        this.length = 0;
    }

    appendValue(value: any) {
        this.history[this.writeIndex] = value;

        if (this.hasLooped) {
            this.zeroIndex++;
            if (this.zeroIndex >= this.length) this.zeroIndex = 0;
        } else {
            this.length++;
        }

        this.writeIndex++;
        if (this.writeIndex >= this.historyLength) {
            this.writeIndex = 0;
            this.hasLooped = true;
        }
    }

    /**
     *
     * @param {string[]} channels - The channels to get the history of
     * @param {number?} lookback - The number of entries behind to look back on the history
     */
    getHistory(lookback: number | undefined) {
        lookback = Math.min(lookback || this.historyLength, this.length);

        let channelHistory = Array(lookback);

        for (let j = 0; j < lookback; j++) {
            channelHistory[channelHistory.length - j - 1] = this.getValueFromEnd(j);
        }

        return channelHistory;
    }

    getValueFromEnd(indicesFromEnd: number) {
        return this.history[this._wrapIndex(this.writeIndex - 1 - indicesFromEnd, this.length)];
    }

    getValue(index: number) {
        return this.history[this._absoluteToOffsetIndex(index)];
    }

    setValue(index: number, value: any) {
        return (this.history[this._absoluteToOffsetIndex(index)] = value);
    }

    [Symbol.iterator]() {
        let i = 0;

        return {
            next: () => {
                return i < this.length
                    ? { value: this.getValue(i++), done: false }
                    : { done: true };
            },
        };
    }

    /**
     * Converts a an absolute index (starting at 0) to a relative index (starting at insertIndices[channelName])
     * @param {number} index - The 0 based index to convert to the relative index stored internally
     */
    _absoluteToOffsetIndex(index: number) {
        return this._wrapIndex(this.zeroIndex + index, this.length);
    }

    _wrapIndex(index: number, arrayLength: number) {
        return ((index % arrayLength) + arrayLength) % arrayLength;
    }
}
